// // RoutingFile.jsx
// import { Routes, Route } from 'react-router-dom';
// import Layout from './Layout';

// import App from './App';


// import AboutUs from './AboutUs';
// import Contact from './ContactUs';
// import SearchResults from './SearchResults';
// import ProductDetail from './ProductDetail';
// import ScrollToTop from './ScrollToTop'; // scroll restoration
// import Companyoverview from "./CompanyOverview";
// import PrivacyPolicy from "./PrivacyPolicy";
// import TermsAndcondition from "./Terms&Conditions";
// import Gallery from "./Gallery";
// import LatestUpdate from "./LatestUpdates";
// import BlogsAndArticles from "./Blogs&Articles";
// import WebsiteDevelopment from "./Website Development";
// import MobileAppDevelopment from "./Mobile App Development";
// import SoftwareSolutions from "./Software Solutions";
// import MaintenanceAndSupport from "./Maintenance & Support";
// import DigitalMarketing from "./Digital Marketing";
// import SalesForceDevelopment from "./SalesForceDevelopment";
// import EnterpriseSoftware from "./EnterpriseSoftware";
// import ERPSystem from "./ERPSystem";
// import IOSAppDevelopment from "./IOSAppDevelopment";
// import AndroidAppDevelopment from"./AndroidAppDevelopment";
// import CrossPlatformAppDevelopment from "./CrossPlatformAppDevelopment";
// import PortfolioWebsiteDevelopment from "./PortfolioWebsiteDevelopment";
// import StaticWebsiteDevelopment from "./StaticWebsiteDevelopment";
// import DynamicWebsiteDevelopment from "./DynamicWebsiteDevelopment";
// import EcommerceWebsiteDevelopment from "./EcommerceWebsiteDevelopment";
// import BlogWebsiteDevelopment from "./BlogWebsiteDevelopment";
// import LandingPageDevelopment from "./LandingPageDevelopment";
// import Career from "./Career";
// function RoutingFile() {
//     return (
//        <>
//             <ScrollToTop />
//             <Routes>
//                 <Route path="/" element={<Layout />}>
//                     <Route index element={<App />} />
//                     <Route path="WebsiteDevelopment" element={<WebsiteDevelopment />} />
//                     <Route path="MobileAppDevelopment" element={<MobileAppDevelopment />} />
//                     <Route path="SoftwareSolutions" element={<SoftwareSolutions />} />
//                     <Route path="MaintenanceAndSupport" element={<MaintenanceAndSupport />} />
//                     <Route path="DigitalMarketing" element={<DigitalMarketing />} />
//                     <Route path="SalesForceDevelopment" element={<SalesForceDevelopment />} />
//                     <Route path="EnterpriseSoftware" element={<EnterpriseSoftware />} />
//                     <Route path="ERPSystem" element={<ERPSystem />} />
//                     <Route path="IOSAppDevelopment" element={<IOSAppDevelopment />} />
//                     <Route path="AndroidAppDevelopment" element={<AndroidAppDevelopment />} />
//                     <Route path="CrossPlatformAppDevelopment" element={<CrossPlatformAppDevelopment />} />


//                     <Route path="PortfolioWebsiteDevelopment" element={<PortfolioWebsiteDevelopment/>} />
//                     <Route path="StaticWebsiteDevelopment" element={<StaticWebsiteDevelopment />} />
//                     <Route path="DynamicWebsiteDevelopment" element={<DynamicWebsiteDevelopment />} />

//                     <Route path="EcommerceWebsiteDevelopment" element={<EcommerceWebsiteDevelopment />} />
//                     <Route path="BlogWebsiteDevelopment" element={<BlogWebsiteDevelopment />} />
//                     <Route path="LandingPageDevelopment" element={<LandingPageDevelopment/>} />
//                     <Route path="Career" element={<Career />} />
//                     <Route path="AboutUs" element={<AboutUs />} />
//                     <Route path="Contact" element={<Contact />} />
//                     <Route path="search" element={<SearchResults />} />

//                     {/* ✅ Updated route with slug */}
//                     <Route path="product/:slug" element={<ProductDetail />} />

//                     <Route path="Companyoveriew" element={<Companyoverview />} />
//                     <Route path="TermsAndcondition" element={<TermsAndcondition />} />
//                     <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
//                     <Route path="Gallery" element={<Gallery />} />
//                     <Route path="LatestUpdate" element={<LatestUpdate />} />
//                     <Route path="BlogsAndArticles" element={<BlogsAndArticles />} />
//                 </Route>
//             </Routes>
//        </>
//     );
// }

// export default RoutingFile;





import { Routes, Route } from 'react-router-dom';

import Layout from './Layout';
import App from './App';
import WelcomePage from './WelcomePage';

import AboutUs from './AboutUs';
import Contact from './ContactUs';
import SearchResults from './SearchResults';
import ProductDetail from './ProductDetail';
import ScrollToTop from './ScrollToTop';
import Internship from "./Internship";

import Companyoverview from './CompanyOverview';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndcondition from './Terms&Conditions';
import Gallery from './Gallery';
import LatestUpdate from './LatestUpdates';
import BlogsAndArticles from './Blogs&Articles';
import ComputerClasses from './ComputerClasses';
import SchoolCodingCourse from './SchoolCodingCourse';

import WebsiteDevelopment from './Website Development';
import MobileAppDevelopment from './Mobile App Development';
import SoftwareSolutions from './Software Solutions';
import MaintenanceAndSupport from './Maintenance & Support';
import DigitalMarketing from './Digital Marketing';
import SalesForceDevelopment from './SalesForceDevelopment';
import EnterpriseSoftware from './EnterpriseSoftware';
import ERPSystem from './ERPSystem';
import IOSAppDevelopment from './IOSAppDevelopment';
import AndroidAppDevelopment from './AndroidAppDevelopment';
import CrossPlatformAppDevelopment from './CrossPlatformAppDevelopment';
import CoursesPage from './CoursesPage';
import PortfolioWebsiteDevelopment from './PortfolioWebsiteDevelopment';
import StaticWebsiteDevelopment from './StaticWebsiteDevelopment';
import DynamicWebsiteDevelopment from './DynamicWebsiteDevelopment';
import EcommerceWebsiteDevelopment from './EcommerceWebsiteDevelopment';
import BlogWebsiteDevelopment from './BlogWebsiteDevelopment';
import LandingPageDevelopment from './LandingPageDevelopment';
import Career from './Career';

function RoutingFile() {
    return (
        <>
            <ScrollToTop />

            <Routes>
                {/* Welcome page - first page */}
                <Route path="/" element={<WelcomePage />} />
                <Route path="/courses" element={<CoursesPage />} />
                <Route
                    path="/schoolcodingcourse"
                    element={<SchoolCodingCourse />}
                />
                <Route path="/internship" element={<Internship />} />
                <Route
                    path="/computer-classes"
                    element={<ComputerClasses />}
                />
                {/* Existing website routes - preserved */}
                <Route path="/" element={<Layout />}>
                    <Route path="Home" element={<App />} />

                    <Route path="WebsiteDevelopment" element={<WebsiteDevelopment />} />
                    <Route path="MobileAppDevelopment" element={<MobileAppDevelopment />} />
                    <Route path="SoftwareSolutions" element={<SoftwareSolutions />} />
                    <Route path="MaintenanceAndSupport" element={<MaintenanceAndSupport />} />
                    <Route path="DigitalMarketing" element={<DigitalMarketing />} />
                    <Route path="SalesForceDevelopment" element={<SalesForceDevelopment />} />
                    <Route path="EnterpriseSoftware" element={<EnterpriseSoftware />} />
                    <Route path="ERPSystem" element={<ERPSystem />} />
                    <Route path="IOSAppDevelopment" element={<IOSAppDevelopment />} />
                    <Route path="AndroidAppDevelopment" element={<AndroidAppDevelopment />} />
                    <Route path="CrossPlatformAppDevelopment" element={<CrossPlatformAppDevelopment />} />

                    <Route path="PortfolioWebsiteDevelopment" element={<PortfolioWebsiteDevelopment />} />
                    <Route path="StaticWebsiteDevelopment" element={<StaticWebsiteDevelopment />} />
                    <Route path="DynamicWebsiteDevelopment" element={<DynamicWebsiteDevelopment />} />
                    <Route path="EcommerceWebsiteDevelopment" element={<EcommerceWebsiteDevelopment />} />
                    <Route path="BlogWebsiteDevelopment" element={<BlogWebsiteDevelopment />} />
                    <Route path="LandingPageDevelopment" element={<LandingPageDevelopment />} />

                    <Route path="Career" element={<Career />} />
                    <Route path="AboutUs" element={<AboutUs />} />
                    <Route path="Contact" element={<Contact />} />
                    <Route path="contact" element={<Contact />} />
                    <Route path="search" element={<SearchResults />} />
                    <Route path="product/:slug" element={<ProductDetail />} />

                    <Route path="Companyoveriew" element={<Companyoverview />} />
                    <Route path="TermsAndcondition" element={<TermsAndcondition />} />
                    <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
                    <Route path="Gallery" element={<Gallery />} />
                    <Route path="LatestUpdate" element={<LatestUpdate />} />
                    <Route path="BlogsAndArticles" element={<BlogsAndArticles />} />
                </Route>
            </Routes>
        </>
    );
}

export default RoutingFile;
